// Enable only after the central Client Studio route and business access pass E2E checks.
export const BBW_INSIGHTS_URL = "https://blaircreativestudio.com/admin/client-center/insights/";
export const BBW_INSIGHTS_LABEL = "Open BBW insights in BCS";
export function bbwInsightsConfig(env = {}) {
  const enabled = env.REACT_APP_BCS_CLIENT_INSIGHTS_ENABLED === "true";
  return { enabled, href: enabled ? BBW_INSIGHTS_URL : undefined,
    notice: enabled ? "Client Studio sign-in may be required. Only your authorized businesses are shown." : "Client Insights connection is being prepared. This link will open when access is verified." };
}
const config = bbwInsightsConfig(process.env);
export const BBW_INSIGHTS_ENABLED = config.enabled;
export const BBW_INSIGHTS_HREF = config.href;
export const BBW_INSIGHTS_SIGN_IN_NOTICE = config.notice;
